import { render, staticRenderFns } from "./ListSPTPage.vue?vue&type=template&id=19993e60&scoped=true&"
import script from "./ListSPTPage.vue?vue&type=script&lang=js&"
export * from "./ListSPTPage.vue?vue&type=script&lang=js&"
import style0 from "./ListSPTPage.vue?vue&type=style&index=0&id=19993e60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19993e60",
  null
  
)

export default component.exports